export default {
  zagFocus: (elem) => {
    elem.setAttribute('data-tabindex', elem.getAttribute('tabindex'));
    elem.setAttribute('tabindex', -1)
    const clear = (evt) => {
        evt.currentTarget.setAttribute('tabindex', evt.currentTarget.getAttribute('data-tabindex'));
        evt.currentTarget.removeAttribute('data-tabindex');
    }
    elem.addEventListener('blur', clear);
    // elem.addEventListener("focusout", clear);
    // console.log(elem);
    elem.focus();
  },
  GetViewport: function () {
    var e = window, a = 'inner';
    if (!('innerWidth' in window)) {
        a = 'client';
        e = document.documentElement || document.body;
    }
    return { width: e[a + 'Width'], height: e[a + 'Height'] };
  },
  GetCurrentBP: function () {
      var bp = '';
      var viewportWidth = this.GetViewport().width;

      if (viewportWidth >= 1200) {
          bp = 'lg';
      } else if (viewportWidth >= 992 && viewportWidth <= 1199) {
          bp = 'md';
      } else if (viewportWidth >= 768 && viewportWidth <= 991) {
          bp = 'sm';
      } else if (viewportWidth <= 767) {
          bp = 'xs';
      }
      return bp;
  }
}